import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: true,
    name: 'auditDate',
    pure: true,
})
export class AuditDatePipe implements PipeTransform {
    transform(value: string): string {
        const date = new Date(value);
        return new Intl.DateTimeFormat('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
        }).format(date);
    }
}
